export class DialogData {
    title: string;
    bodyText: string;
    cancelButtonText: string;
    confirmationButtonText: string;
}
